import STAFFING_TYPES from "../types/staffingTypes";

const initialState = {
  loading: false,
  staffingInfo: null,
  notification: null,
  roleInfo: {},
};

export default function facilityReducer(state = initialState, action) {
  switch (action.type) {
    case STAFFING_TYPES.UPDATE_STAFFING_DATA:
      return {
        ...state,
        staffingInfo: action.payload,
      };
    case STAFFING_TYPES.UPDATE_ROLE_DATA:
      return {
        ...state,
        roleInfo: action.payload,
      };
    case STAFFING_TYPES.UPDATE_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    case STAFFING_TYPES.CLEAR_STAFFING:
      return {
        ...state,
        staffingInfo: null,
        notification: null,
      };
    default:
      return state;
  }
}
